import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { api } from "@/lib/api";
import { Megaphone, ArrowRight } from "@phosphor-icons/react";

const TAG_STYLE = {
  New: { color: "var(--bk-accent)", bg: "#FBF3E7" },
  Improved: { color: "#2F6B4F", bg: "var(--bk-success-bg)" },
  Fixed: { color: "#8A6A3B", bg: "#F6EEDF" },
};

export default function WhatsNew() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/changelog")
      .then((r) => setEntries(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen" style={{ background: "var(--bk-page)" }}>
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-14" data-testid="whatsnew-page">
        <div className="flex items-center gap-2.5 mb-3">
          <Megaphone size={26} weight="duotone" color="var(--bk-accent)" />
          <span className="text-xs uppercase tracking-[0.18em] font-semibold" style={{ color: "var(--bk-accent)" }}>Product updates</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight" style={{ color: "var(--bk-text)" }}>
          What's new in IronRoot
        </h1>
        <p className="text-base mt-4" style={{ color: "var(--bk-text-2)" }}>
          We ship improvements constantly — often straight from your feedback. Here's what's changed lately.
        </p>

        <div className="mt-12">
          {loading ? (
            <p className="text-sm" style={{ color: "var(--bk-text-2)" }}>Loading…</p>
          ) : entries.length === 0 ? (
            <div className="bk-card p-8 text-center">
              <p className="font-display text-xl font-bold" style={{ color: "var(--bk-text)" }}>Updates are on the way</p>
              <p className="text-sm mt-2" style={{ color: "var(--bk-text-2)" }}>
                We're just getting started. Have an idea? Use the Feedback button — the best ones show up right here.
              </p>
              <Link to="/register" className="bk-btn-primary inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-md text-sm font-semibold">
                Start your free trial <ArrowRight size={16} weight="bold" />
              </Link>
            </div>
          ) : (
            <div className="relative pl-6" style={{ borderLeft: "2px solid var(--bk-border)" }}>
              {entries.map((e) => {
                const tag = TAG_STYLE[e.tag] || TAG_STYLE.New;
                return (
                  <div key={e.id} data-testid={`whatsnew-entry-${e.id}`} className="relative mb-10">
                    <span className="absolute -left-[31px] top-1.5 w-3.5 h-3.5 rounded-full border-2" style={{ background: "#fff", borderColor: "var(--bk-accent)" }} />
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="text-xs font-semibold px-2.5 py-0.5 rounded-full" style={{ background: tag.bg, color: tag.color }}>{e.tag}</span>
                      <span className="text-xs" style={{ color: "var(--bk-text-2)" }}>
                        {e.created_at ? new Date(e.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : ""}
                      </span>
                    </div>
                    <h2 className="font-display text-xl font-bold mt-2" style={{ color: "var(--bk-text)" }}>{e.title}</h2>
                    <p className="text-base mt-1.5 whitespace-pre-line leading-relaxed" style={{ color: "var(--bk-text-2)" }}>{e.body}</p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
